export const STATUS = {
  pending: { label: "Pending", cls: "bg-amber-500/10 text-amber-400 border-amber-500/30" },
  charged: { label: "Charged", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" },
  partial: { label: "Partial Charge", cls: "bg-cyan-500/10 text-cyan-400 border-cyan-500/30" },
  declined: { label: "Declined", cls: "bg-rose-500/10 text-rose-400 border-rose-500/30" },
  failed: { label: "Failed", cls: "bg-red-950/40 text-red-400 border-red-500/30" },
  voided: { label: "Voided", cls: "bg-slate-800 text-slate-400 border-slate-700" },
};

export const BILLING = {
  full_agency: { label: "Full Agency Charge", short: "Full Agency", cls: "bg-purple-500/10 text-purple-300 border-purple-500/20",
    help: "Gross amount processed on agency merchant" },
  split: { label: "Split Charge", short: "Split", cls: "bg-blue-500/10 text-blue-300 border-blue-500/20",
    help: "Supplier charges net cost; agency charges MCO only" },
  mco_only: { label: "MCO Only", short: "MCO Only", cls: "bg-amber-500/10 text-amber-300 border-amber-500/20",
    help: "Client pays supplier direct; agency charges markup only" },
};

export const PRODUCTS = ["Flight", "Hotel", "Car Rental", "Package", "Date Change / Cancellation"];
export const CARD_TYPES = ["Visa", "Mastercard", "Amex", "Discover"];
export const DOC_KINDS = {
  e_ticket: "E-ticket", passport_scan: "Passport scan", card_auth_form: "Card authorization form",
  invoice: "Invoice", voucher: "Voucher / Confirmation", other: "Other",
};
export const ROLE_LABEL = { agent: "Sales Agent", payment_team: "Payment Desk", admin: "Super Admin" };

export function chargeTarget(b) {
  return b.billing_type === "full_agency" ? Number(b.gross_amount) : Number(b.mco);
}

export function merchantCls(name = "") {
  return /ticket centre/i.test(name)
    ? "bg-indigo-500/10 text-indigo-300 border-indigo-500/30"
    : "bg-sky-500/10 text-sky-300 border-sky-500/30";
}

export function todayStr() {
  return new Date().toISOString().slice(0, 10);
}
export function monthStartStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-01`;
}
